<template>
  <div id="extra-component-google-map-demo">
    <google-map-info-window></google-map-info-window>
  </div>
</template>

<script>
import GoogleMapInfoWindow from "./GoogleMapInfoWindow.vue";

export default {
  components: {
    GoogleMapInfoWindow
  }
};
</script>